











































import Vue from "vue";
import Component from "vue-class-component";
import { MedicalInvoice } from "@/components/medicalEdit/types";
import NumberInput from "@/components/common/NumberInput.vue";
import { Prop } from "vue-property-decorator";

@Component({
  components: {
    NumberInput
  }
})
export default class Money extends Vue {
  @Prop() tab!: MedicalInvoice;
}
